export const styles = theme => ({
  root: {
    marginTop: theme.spacing(5),
    textAlign: 'center',
  },
});
